
 $('.slider-show').slick({
    autoplay:false,
    speed:300 ,
    lazyLoad: 'ondemand',
    slidesToShow:1,
    slideToscroll:1,
    arrows:false,
    dots:true,
    infinite: true,//スライドをループさせるかどうか。初期値はtrue。
    centerMode: true, //要素を中央寄せ
    centerPadding: '10%'//左右の画像が見える幅
   
});